<template>
  <app-page :title="$t('jobs.title')" :subtitle="$t('jobs.subtitle')" icon="briefcase">
    <template v-slot:infobox>
      <sme-info-box :title="$t('jobs.infoBox.aboutTitle')" id="about-jobs" save-state>
        <p>{{ $t('jobs.infoBox.aboutBody1') }}</p>
        <p>{{ $t('jobs.infoBox.aboutBody2') }}</p>
        <div class="mt-3">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>{{ $t('jobs.fields.jobCode') }}</th>
                <th>{{ $t('jobs.infoBox.rateHeader') }}</th>
                <th>{{ $t('jobs.fields.multiplier') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('jobs.infoBox.jobCodeExplanation') }}</td>
                <td>{{ $t('jobs.infoBox.rateExplanation') }}</td>
                <td>{{ $t('jobs.infoBox.multiplierExplanation') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </sme-info-box>
      <sme-info-box :title="$t('jobs.infoBox.addTitle')" id="adding-jobs" save-state>
        <p>
          <i18n path="jobs.infoBox.addIntegrationBody" tag="span">
            <template #link
              ><router-link :to="{ name: 'sme-integrations' }">{{
                $t('common.integrationLinkText')
              }}</router-link></template
            >
          </i18n>
        </p>
        <p v-if="canAddJobs">
          <i18n path="jobs.infoBox.addManualBody" tag="span">
            <template #link
              ><router-link :to="{ name: 'sftp-bulk-upload', query: { entity: 'jobs' } }">{{
                $t('common.inBulkLinkText')
              }}</router-link></template
            >
          </i18n>
        </p>
      </sme-info-box>
      <sme-info-box :title="$t('jobs.infoBox.editTitle')" id="editing-jobs" save-state>
        <p v-if="canAddJobs">{{ $t('jobs.infoBox.editUploadedBody') }}</p>
        <p>{{ $t('jobs.infoBox.editManualBody') }}</p>
        <p v-if="!canAddJobs">{{ $t('jobs.infoBox.editIntegratedBody') }}</p>
      </sme-info-box>
    </template>
    <template v-slot:header v-if="State.state.claims.a">
      <b-button
        v-if="canAddJobs"
        :to="{ name: 'sftp-bulk-upload', query: { entity: 'jobs' } }"
        variant="outline-primary"
      >
        <font-awesome-icon :icon="['fal', 'upload']" class="mr-2" /> {{ $t('common.bulkImportButton') }}
      </b-button>
    </template>

    <template v-slot:custom-content>
      <b-col>
        <sme-alert v-if="!canViewJobs" level="danger">
          {{ $t('jobs.noPermissionAlert') }}
        </sme-alert>
        <b-card v-else>
          <jobs-list class="mt-3" />
        </b-card>
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import AppPage from '@/components/AppPage.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import SmeInfoBox from '@/components/atoms/SmeInfoBox.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import JobsList from '@/pages/jobs/components/JobsList.vue';
import State from '@/state/State';

const { canAddJobs, canViewJobs } = useFeatureFlags();
</script>
